document.addEventListener('DOMContentLoaded', function() {
  // Select all hero videos (desktop + mobile)
  document.querySelectorAll('.hero__video').forEach(function(video) {
    video.muted = false;    // unmute the video
    video.controls = true;  // show video controls
  });
});
